import {useRef, useState, useEffect, use} from 'react';
import './styles.css';

const EagleTrackerScoreBug = (prop) => {
  const { eagleCount } = prop;
  const [ isReveal, setReveal ] = useState(false);
  const [ isCountVisible, setCountVisible ] = useState(false);
  const [ currentCount, setCurrentCount ] = useState()
  const [ newCount, setNewCount ] = useState();
  const revealTimeout = useRef();

  useEffect(() => {
    // Setup recurring reveal on page load
    handleRevealEnd();
  }, []);

  useEffect(() => { // Set new count when eagle count changes
    console.info(`Eagle count: ${eagleCount}`);
    setNewCount(eagleCount);
  }, [ eagleCount ]);

  useEffect(() => { // Show count if current count is a valid number
    if (currentCount === undefined) { return; }
    console.info(`Current count: ${currentCount}`);

    setTimeout(() => {
      setCountVisible(true);
    }, 500);
  }, [ currentCount ]);

  useEffect(() => { // Set current count for number animation
    if (newCount === undefined) { return; }
    console.info(`New count: ${newCount}`);

    if (newCount > currentCount - 1) {
      setCurrentCount(newCount - 1);
    }

    setTimeout(() => {
      setCurrentCount(newCount);
    }, newCount === 0 ? 0 : 2900); // Same timeout as ball animation duration, except for 0 count

    setTimeout(() => {
      if (newCount > 0 && !isReveal) {
        console.log(`Triggering reveal. isReveal: ${isReveal}`);
        setReveal(true);
      }
    }, 2700); // 300ms lower than previous timeout

  }, [ newCount ]);

  useEffect(() => {
    if (isReveal) {
      console.log(`Clearing reveal timeout: ${revealTimeout.current}`);
      clearTimeout(revealTimeout.current);
    }
  }, [ isReveal ]);

  const handleRevealEnd = () => {
    setReveal(false);
    revealTimeout.current = setTimeout(() => {
      setReveal(true);
    }, 60000);
    console.log(`Set new 60 second reveal timout: ${revealTimeout.current}`);
  };

  return (
  <div style={styles.container}>

    <div style={styles.background}>
      <div style={styles.backgroundContentLeft}>
        Eagles for Impact Tracker
      </div>
      <div style={styles.backgroundContentRight}>
        <div style={styles.backgroundLogo}>
          <img style={styles.logoImage} src={require('./logo_black.png')} alt='Morgan Stanley' />
        </div>
        <div>Total Donation:&nbsp;
          <span style={styles.donationAmount}>
            {
              new Intl.NumberFormat('en-US', {
                style: 'currency', 
                currency: 'USD', 
                minimumFractionDigits: 0, 
                maximumFractionDigits: 0
              }).format(currentCount * 5000)
            }
          </span>
        </div>
      </div>
    </div>

    <div style={styles.ballLeft} className={`ball left ${isReveal ? 'reveal' : ''}`}>
      <svg width="100%" height="100%" viewBox="0 0 40 145" xmlns="http://www.w3.org/2000/svg">
        <path d="M 116 -38 A 10 10 0 0 0 116 183 L 0 183 L 0 0 Z" fill="#003061" />
      </svg>
    </div>

    <div style={styles.ballRight} className={`ball right ${isReveal ? 'reveal' : ''}`}>
      <svg width="100%" height="100%" viewBox="0 0 40 145" xmlns="http://www.w3.org/2000/svg">
        <path d="M -77 -38 A 10 10 0 0 1 -77 183 L 40 183 L 40 0 Z" fill="#003061" />
      </svg>
    </div>

    <div style={styles.foregroundLeft} className={`foreground left ${isReveal ? 'reveal' : ''}`} onAnimationEnd={handleRevealEnd}>
      <div style={styles.foregroundContentLeft}>
        Eagles for Impact Tracker
      </div>
    </div>

    <div style={styles.foregroundRight} className={`foreground right ${isReveal ? 'reveal' : ''}`}>
      <div style={styles.foregroundContentRight}>
        <div style={styles.foregroundLogo}>
          {/*<img style={styles.logoImage} src={require('./logo_white.png')} alt='Morgan Stanley' />*/}
          Morgan Stanley
        </div>
        <div>&nbsp;is proud to support First Tee.</div>
      </div>
    </div>

    <div style={{...styles.ballCenter, ...{ display: isCountVisible ? 'block' : 'none' }}}>
      <div style={styles.eagleCount} className={`eagle-count ${newCount != currentCount ? 'increment' : ''}`}>{currentCount}</div>
      <div style={styles.nextEagleCount} className={`eagle-count ${newCount != currentCount ? 'increment' : ''}`}>{newCount}</div>
    </div>
  </div>
  );
};

const variables = {
  '--canvas-height': '290px',
  '--canvas-width': '3520px',
  '--font-size': '4.2em',
  '--side-margin': '80px',
  '--ball-content-width': '440px',
  '--reveal-closed-width': 'calc(var(--canvas-width) / 2 - var(--ball-content-width) / 2)',
  '--reveal-duration': '16s'
};

//const blue = '#003061';
const blue = '#002e5d';

const foreground = {
  background: blue,
  display: 'flex',
  alignItems: 'center',
  width: 'calc(var(--reveal-closed-width))',
  position: 'absolute',
  top: '0',
  bottom: '0',
  overflow: 'hidden'
};

const content = {
  color: '#ffffff',
  fontFamily: 'MorganStanley',
  position: 'absolute',
};

const contentLeft = {
  fontWeight: 'bold',
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  left: 'calc(var(--side-margin))',
  width: 'calc(var(--canvas-width) / 2 - var(--side-margin))'
};

const contentRight = {
  fontWeight: 'normal',
  textAlign: 'right',
  display: 'flex',
  justifyContent: 'space-between',
  right: 'calc(var(--side-margin))',
  width: 'calc(var(--canvas-width) / 2)'
};

const ball = {
  position: 'absolute',
  top: '0',
  bottom: '0',
  width: '80px',
  zIndex: '99'
};

const logo = {
  fontWeight: 'medium',
  marginLeft: '380px',
  paddingTop: '12px',
  height: '66.5px',
  width: '462px',
  display: 'flex',
  alignItems: 'right',
  justifyContent: 'center'
};

const styles = {
  container: { ...variables, ...{
    fontSize: 'calc(var(--font-size)',
    height: 'calc(var(--canvas-height))',
    width: 'calc(var(--canvas-width))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    overflow: 'hidden'
  }},

  background: {
    background: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0'
  },

  backgroundContentLeft: { ...content, ...contentLeft, ...{
    color: blue,
    fontSize: '1.05em'
  }},

  backgroundContentRight: { ...content, ...contentRight, ...{
    color: blue
  }},

  foregroundLeft: { ...foreground, ...{
    left: '-50px',
    width: 'calc(var(--reveal-closed-width) + 40px)'
  }},

  foregroundRight: { ...foreground, ...{
    right: '-50px',
    width: 'calc(var(--reveal-closed-width) + 41px)'
  }},

  foregroundContentLeft: { ...content, ...contentLeft, ...{
    fontSize: '1.05em',
    left: 'calc(var(--side-margin) + 40px)'
  }},

  foregroundContentRight: { ...content, ...contentRight, ...{
    right: 'calc(var(--side-margin) + 40px)'
  }},

  ballLeft: { ...ball, ...{
    left: 'calc(var(--reveal-closed-width) - 10px)'
  }},

  ballRight: { ...ball, ...{
    left: 'calc(var(--canvas-width) - var(--reveal-closed-width) - 70px)'
  }},

  ballCenter: {
    color: blue,
    fontFamily: 'MorganStanley',
    fontSize: '3.5em',
    fontWeight: 'bold',
    zIndex: '100',
    display: 'none'
  },

  eagleCount: {
    marginTop: 'calc(var(--canvas-height) - 10px)',
    textAlign: 'center',
    width: '100%'
  },

  nextEagleCount: {
    textAlign: 'center',
    width: '100%'
  },

  backgroundLogo: { ...logo, ...{

  }},

  foregroundLogo: { ...logo, ...{
    marginLeft: '415px',
    paddingTop: '0',
    height: 'unset',
    width: 'unset',
  }},

  logoImage: {
    maxWidth: '100%',
    width: '100%'
  },

  donationAmount: {
    fontWeight: 'bold'
  }
};

export default EagleTrackerScoreBug;